<template>
  <div class="product-select">
    <div
        class="ps-field"
        :class="{ 'ps-disabled': disabled }"
        @click="!disabled && openPicker()"
        @keydown.enter.prevent="!disabled && openPicker()"
        tabindex="0"
        role="button"
        aria-haspopup="dialog"
    >
      <div v-if="selectedProduct" class="ps-value">
        <img v-if="selectedProduct.image" class="ps-thumb" :src="img_source(selectedProduct.image)" alt="">
        <div class="ps-texts">
          <div class="ps-name">{{ selectedProduct.name }}</div>
          <div class="ps-code">{{ selectedProduct.sixteen_digit_code || '—' }}</div>
        </div>
      </div>
      <div v-else class="ps-placeholder">
        {{ placeholder || label || 'انتخاب محصول' }}
      </div>
      <div class="ps-icons">
        <button
            v-if="selectedProduct && !disabled"
            class="ps-clear"
            @click.stop="clearSelection"
            :title="'پاک کردن'">×</button>
        <span class="ps-caret">▾</span>
      </div>
    </div>

    <div v-if="showPicker" class="ps-dialog-backdrop" @click.self="closePicker">
      <div class="ps-dialog" role="dialog" aria-modal="true">
        <div class="ps-dialog-header">
          <div class="ps-title">انتخاب محصول</div>
          <button class="ps-close" @click="closePicker">×</button>
        </div>

        <div class="ps-filters">
          <input
              v-model="filters.search_value"
              class="ps-input"
              type="text"
              placeholder="نام"
              @keyup.enter="applyFilters"
          />
          <input
              v-model="filters.sku"
              class="ps-input"
              type="text"
              placeholder="SKU"
              @keyup.enter="applyFilters"
          />
          <brand-select
              v-model="filters.brand_in"
              class="ps-brand-input"
              @change="applyFilters"
          ></brand-select>

          <button class="ps-btn ps-btn-primary" @click="applyFilters">اعمال فیلتر</button>
          <button class="ps-btn" @click="resetFilters">پاک‌سازی</button>
        </div>

        <div class="ps-table-wrap">
          <table class="ps-table ma-2">
            <thead>
            <tr>
              <th style="width:56px;">تصویر</th>
              <th>نام محصول</th>
              <th style="width:180px;">SKU</th>
              <th style="width:90px;">وضعیت</th>
              <th style="width:80px;">موجودی</th>
              <th style="width:120px;">انتخاب</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loadingList">
              <td colspan="6" class="ps-center">در حال بارگذاری...</td>
            </tr>
            <tr v-else-if="productsList.length === 0">
              <td colspan="6" class="ps-center ps-muted">محصولی یافت نشد</td>
            </tr>
            <tr
                v-for="p in productsList"
                :key="p.id"
                @dblclick="!isOutOfStock(p) && selectProduct(p)"
                class="ps-row"
                :class="{
                  'ps-row-selected':
                    (!multiple && isEqualId(item, p.id)) ||
                    (multiple && Array.isArray(item) && item.some(id => isEqualId(id, p.id))),
                  'ps-row-disabled': isOutOfStock(p)
                }"
            >
              <td><img v-if="p.image" class="ps-thumb" :src="img_source(p.image)" alt=""></td>
              <td><div class="ps-name">{{ p.name }}</div></td>
              <td class="ps-code">{{ p.sixteen_digit_code || '—' }}</td>
              <td>
                <span class="ps-stock-badge" :class="p.in_stock ? 'ps-stock-in' : 'ps-stock-out'">
                  {{ p.in_stock ? 'موجود' : 'ناموجود' }}
                </span>
              </td>
              <td class="ps-center">{{ p.inventory_count != null ? p.inventory_count : '—' }}</td>
              <td>
                <button
                    class="ps-btn ps-btn-primary"
                    :disabled="isOutOfStock(p)"
                    @click="selectProduct(p)"
                >انتخاب</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="ps-pagination">
          <div class="ps-pageinfo mt-3 mr-2">
            نمایش {{ offset + 1 }} تا {{ Math.min(offset + limit, total) }} از {{ total }}
          </div>
          <div class="ps-pager mt-2 mr-3">
            <button class="ps-btn ml-2" :disabled="offset===0" @click="prevPage">قبلی</button>
            <button class="ps-btn" :disabled="offset + limit >= total" @click="nextPage">بعدی</button>
          </div>
        </div>

        <div class="ps-dialog-actions">
          <button class="ps-btn" @click="closePicker">بستن</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrandSelect from "@/components/selects/BrandSelect";
export default {
  name: 'ProductsSelect',
  components: {BrandSelect},
  model: { prop: 'value', event: 'input' },

  props: {
    value: {},
    product_type: { default: null },
    label: { default: null },
    placeholder: { default: null },
    disabled: { default: false },
    multiple: { default: false },
    presetItems: { type: Array, default: () => [] },
    lazy: { type: Boolean, default: true },
  },

  data() {
    return {
      byId: Object.create(null),
      item: null,
      showPicker: false,
      loadingList: false,
      productsList: [],
      total: 0,
      limit: 10,
      offset: 0,
      filters: { search_value: '', sku: '' , brand_in: ''},
    };
  },

  computed: {
    selectedProduct() {
      if (this.multiple) return null;
      const key = this.normalizeId(this.item);
      return key != null && this.byId[key] ? this.byId[key] : null;
    },
  },

  created() {
    if (this.presetItems.length) {
      this.presetItems.forEach(p => {
        if (p && p.id != null) this.$set(this.byId, this.normalizeId(p.id), p);
      });
    }
  },

  mounted() {
    this.setItemFromProp();

    if (!this.multiple && this.value != null && !this.byId[this.normalizeId(this.value)]) {
      this.fetchOneById(this.value);
    } else if (this.multiple && Array.isArray(this.value)) {
      this.value.forEach(id => {
        const k = this.normalizeId(id);
        if (k != null && !this.byId[k]) this.fetchOneById(k);
      });
    }
  },

  methods: {
    normalizeId(id) { return id == null ? id : String(id); },
    isEqualId(a, b) { return this.normalizeId(a) === this.normalizeId(b); },
    isOutOfStock(p) {
      if (p.in_stock === false) return true;
      return p.inventory_count != null && p.inventory_count < 1;
    },

    dedupeById(list) {
      const seen = new Set(); const out = [];
      for (const p of list) {
        if (!p || p.id == null) continue;
        const key = this.normalizeId(p.id);
        if (seen.has(key)) continue;
        seen.add(key); out.push(p);
      }
      return out;
    },

    ensureSelectedVisible() {
      if (!this.multiple && this.item != null) {
        const exists = this.productsList.some(p => p && this.isEqualId(p.id, this.item));
        if (!exists) {
          this.request({
            url: this.endpoint('product/adminSelectProducts'),
            method: 'get',
            params: { id_in: this.item, limit: 1, offset: 0 },
            success: (data) => {
              const p = (data.results || [])[0];
              if (p) {
                this.$set(this.byId, this.normalizeId(p.id), p);
                this.productsList = this.dedupeById([p, ...this.productsList]);
              }
            }
          });
        }
      }

      if (this.multiple && Array.isArray(this.item) && this.item.length) {
        const missingIds = this.item.filter(id => !this.productsList.some(p => p && this.isEqualId(p.id, id)));
        if (missingIds.length) {
          this.request({
            url: this.endpoint('product/adminSelectProducts'),
            method: 'get',
            params: { id_in: missingIds.join(','), limit: missingIds.length, offset: 0 },
            success: (data) => {
              const rows = data.results || [];
              rows.forEach(p => this.$set(this.byId, this.normalizeId(p.id), p));
              this.productsList = this.dedupeById([...rows, ...this.productsList]);
            }
          });
        }
      }
    },

    apiListParams(extra = {}) {
      const params = { limit: this.limit, offset: this.offset, ...extra };
      if (this.filters.search_value) params.search_value = this.filters.search_value;
      if (this.filters.sku) params.sku = this.filters.sku;
      if (this.filters.brand_in) params.brand_in = this.filters.brand_in;
      if (this.product_type) params.product_type__in = this.product_type;
      return params;
    },

    fetchProductsList() {
      this.loadingList = true;
      const params = this.apiListParams();
      this.request({
        url: this.endpoint('product/adminSelectProducts'),
        method: 'get',
        params,
        success: (data) => {
          this.productsList = data.results || [];
          this.total = data.count || 0;
          this.productsList.forEach(p => this.$set(this.byId, this.normalizeId(p.id), p));
          this.loadingList = false;
          this.ensureSelectedVisible();
        },
        error: () => { this.loadingList = false; }
      });
    },

    fetchOneById(id) {
      if (id == null) return;
      const norm = this.normalizeId(id);
      this.request({
        url: this.endpoint('product/adminSelectProducts'),
        method: 'get',
        params: { id_in: norm, limit: 1, offset: 0 },
        success: (data) => {
          const p = (data.results || [])[0];
          if (p) this.$set(this.byId, this.normalizeId(p.id), p);
        }
      });
    },

    // UX
    openPicker() {
      this.showPicker = true;
      if (this.productsList.length === 0) {
        this.offset = 0; // 10 تای اول
        this.fetchProductsList();
      } else {
        this.ensureSelectedVisible();
      }
    },
    closePicker() { this.showPicker = false; },
    applyFilters() { this.offset = 0; this.fetchProductsList(); },
    resetFilters() { this.filters.search_value = ''; this.filters.sku = ''; this.filters.brand_in = ''; this.applyFilters(); },
    prevPage() { if (this.offset === 0) return; this.offset = Math.max(0, this.offset - this.limit); this.fetchProductsList(); },
    nextPage() { if (this.offset + this.limit >= this.total) return; this.offset += this.limit; this.fetchProductsList(); },

    selectProduct(p) {
      if (this.isOutOfStock(p)) return;
      const pid = this.normalizeId(p.id);
      if (this.multiple) {
        const next = Array.isArray(this.item) ? this.item.map(this.normalizeId) : [];
        if (!next.includes(pid)) next.push(pid);
        this.$set(this.byId, pid, p);
        this.item = next;
      } else {
        this.$set(this.byId, pid, p);
        this.item = pid;
        this.showPicker = false;
      }
      // آپدیت v-model
      this.$emit('input', this.item);
      this.$emit('change', this.item, p);
      this.$emit('select', p);
    },

    clearSelection() {
      this.item = this.multiple ? [] : null;
      this.$emit('input', this.item);
      this.$emit('change', this.item);
    },

    setItemFromProp() {
      const norm = Array.isArray(this.value) ? this.value.map(this.normalizeId) : this.normalizeId(this.value);
      if (JSON.stringify(norm) !== JSON.stringify(this.item)) this.item = norm;
    },
  },

  watch: {
    value() {
      this.setItemFromProp();
      if (!this.multiple && this.value != null && !this.byId[this.normalizeId(this.value)]) this.fetchOneById(this.value);
      if (this.multiple && Array.isArray(this.value)) {
        this.value.forEach(id => {
          const k = this.normalizeId(id);
          if (k != null && !this.byId[k]) this.fetchOneById(k);
        });
      }
    },

    item(newVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(
          Array.isArray(this.value) ? this.value.map(this.normalizeId) : this.normalizeId(this.value)
      )) {
        this.$emit('input', newVal);
        this.$emit('change', newVal);
      }
    }
  }
};
</script>

<style scoped>
.ps-field {
  display:flex; align-items:center; justify-content:space-between;
  width:100%; min-height:40px; padding:8px 10px; border:1px solid #e5e7eb; border-radius:10px;
  background:#fff; cursor:pointer; outline:none;
}
.ps-field:focus { box-shadow:0 0 0 3px rgba(59,130,246,0.2); }
.ps-disabled { opacity:.6; cursor:not-allowed; }
.ps-value { display:flex; align-items:center; gap:8px; min-width:0; }
.ps-thumb { width:32px; height:32px; border-radius:6px; object-fit:cover; border:1px solid #eee; }
.ps-texts { min-width:0; }
.ps-name { font-size:12px; font-weight:600; color:#111827; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:280px; }
.ps-code { font-size:11px; color:#6b7280; margin-top:2px; }
.ps-placeholder { color:#9ca3af; font-size:12px; }
.ps-icons { display:flex; align-items:center; gap:6px; }
.ps-clear { border:none; background:#f3f4f6; border-radius:6px; padding:0 6px; cursor:pointer; }
.ps-caret { font-size:12px; color:#6b7280; }

.ps-dialog-backdrop {
  position:fixed; inset:0; background:rgba(0,0,0,.35);
  display:flex; align-items:center; justify-content:center; z-index:1000;
}
.ps-dialog {
  width: min(900px, 96vw);
  background:#fff; border-radius:12px; overflow:hidden; box-shadow:0 20px 60px rgba(0,0,0,.25);
  display:flex; flex-direction:column;
}
.ps-dialog-header {
  display:flex; align-items:center; justify-content:space-between;
  padding:10px 14px; border-bottom:1px solid #eee; background:#fafafa;
}
.ps-title { font-weight:700; }
.ps-close { border:none; background:transparent; font-size:20px; line-height:1; cursor:pointer; }

.ps-filters { display:flex; flex-wrap:wrap; gap:2px; padding:12px 14px; }
.ps-input {
  flex:1 1 220px; border:1px solid #e5e7eb; border-radius:8px; padding:8px 10px; min-width:220px;
}
.ps-brand-input {
  flex:1 1 220px; min-width:220px;
}

.ps-btn { border:1px solid #e5e7eb; background:#fff; border-radius:8px; padding:8px 12px; cursor:pointer; }
.ps-btn-primary { background:#2563eb; color:#fff; border-color:#2563eb; }
.ps-btn:disabled { opacity:.5; cursor:not-allowed; }
.ps-row-disabled { opacity:.55; }
.ps-row-disabled .ps-name { color:#9ca3af; }

.ps-table-wrap { overflow:auto; max-height:50vh; }
.ps-table { width:95%; border-collapse:collapse; }
.ps-table th, .ps-table td { border-bottom:1px solid #f1f5f9; padding:10px; text-align:right; }
.ps-row { cursor:pointer; }
.ps-center { text-align:center; }
.ps-muted { color:#94a3b8; }

ps-pagination {
  display:flex; align-items:center; justify-content:space-between;
  padding:10px 14px; border-top:1px solid #f1f5f9; background:#fafafa;
}
.ps-pageinfo { font-size:12px; color:#6b7280; }

.ps-dialog-actions { padding:10px 14px; display:flex; justify-content:flex-end; gap:8px; }
.ps-row-selected { background:#f0f7ff; }
.ps-stock-badge { display:inline-block; padding:2px 8px; border-radius:999px; font-size:11px; font-weight:600; }
.ps-stock-in { background:#dcfce7; color:#15803d; }
.ps-stock-out { background:#fee2e2; color:#b91c1c; }
</style>
